import React, { Component } from 'react';
import { FormModalContainer, FormModalContent, SelectContainer } from './style';
import { CloseIconContainer } from '../style';
import { Text } from '../../../UI/Text';
import { convertModalKeyToModalName, getStartOrFinishLabel, getBeforeOrAfterLabel } from './utils';
import { PreviewItem } from './Previews/PreviewItem';
import { SecondStepFactory } from './SecondStepFactory';
import { secondStepIds, durationTimeIds } from './constants';
import { Row, OuterIndent } from '../../../Layouts';
import { asyncComponent } from '../../../HOC/withAsyncLoaded';
import { modalTypes } from '../../../Containers/GymAdminPanel/GymTv/constants';

const CustomDurationPicker = asyncComponent(() => {
    return import('../../Pickers/CustomTimePicker').then(module => module.default);
});

export class GymTvConfigurationsModal extends Component {
    state = {
        start_display: this.props.startDisplay,
        end_display: this.props.endDisplay,
        selectedItemId: null,
        nextWindowId: null,
    };

    instantSelectActions = (selectedItemId, ...restData) => ({
        selectItem: () => {
            if (this.props.type === modalTypes.BETWEEN_CLASSES) this.setState({ nextWindowId: selectedItemId });
            else if (secondStepIds.includes(selectedItemId)) this.setState({ nextWindowId: selectedItemId });
            else
                this.props.onSelect(this.props.type, {
                    type: this.props.type,
                    content_type: selectedItemId,
                });
        },
    });

    updateDisplayDuration = event => {
        this.setState({ [event.target.name]: event.target.value }, () => {
            this.props.onInputChange(event);
        });
    };

    onDurationChange = duration => {
        this.props.onDurationChange(this.props.type, duration);
    };

    closeNextWindow = () => this.setState({ nextWindowId: null });

    render() {
        const {
            props: { onClose, type, onSelect, workoutsOfTheDay, workoutOfTheWeek },
            state: { nextWindowId, start_display, end_display },
            instantSelectActions,
            closeNextWindow,
            onDurationChange,
        } = this;

        return nextWindowId !== null ? (
            <SecondStepFactory
                initialModalType={type}
                type={nextWindowId}
                onSelect={onSelect}
                onClose={closeNextWindow}
                workoutsOfTheDay={workoutsOfTheDay}
                workoutOfTheWeek={workoutOfTheWeek}
            />
        ) : (
            <FormModalContainer>
                <FormModalContent>
                    <Text alignCenter marginBottom={'16px'} fontSize={22} weight={'bold'}>
                        {convertModalKeyToModalName(type)}
                    </Text>

                    {durationTimeIds.includes(type) && (
                        <Row marginBottom={'32px'}>
                            <Text>{getStartOrFinishLabel(type)} display</Text>

                            <OuterIndent indent={'0 12px'}>
                                {type === 0 ? (
                                    <CustomDurationPicker passData={onDurationChange} initial={start_display} />
                                ) : (
                                    <CustomDurationPicker passData={onDurationChange} initial={end_display} />
                                )}
                            </OuterIndent>

                            <Text>{getBeforeOrAfterLabel(type)}</Text>
                        </Row>
                    )}

                    <CloseIconContainer onClick={onClose}>
                        <i className="fas fa-times" />
                    </CloseIconContainer>

                    <SelectContainer>
                        {[...Array(6)].map((item, index) => (
                            <PreviewItem type={index} {...instantSelectActions(index)} key={index} />
                        ))}
                    </SelectContainer>
                </FormModalContent>
            </FormModalContainer>
        );
    }
}

GymTvConfigurationsModal.defaultProps = {
    type: 0,
    onClose: () => {},
};



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/index.js